<template>
    <MonthPickerGrid
        :class="cn('w-full table-fixed border-separate border-spacing-x-0 border-spacing-y-2', props.class)"
        v-bind="forwardedProps"
    >
        <slot />
    </MonthPickerGrid>
</template>

<script setup lang="ts">
import { cn } from '@/lib/utils';
import { reactiveOmit } from '@vueuse/core';
import type { MonthPickerGridProps } from 'reka-ui';
import { MonthPickerGrid, useForwardProps } from 'reka-ui';
import type { HTMLAttributes } from 'vue';

const props = defineProps<MonthPickerGridProps & { class?: HTMLAttributes['class'] }>();

const delegatedProps = reactiveOmit(props, 'class');

const forwardedProps = useForwardProps(delegatedProps);
</script>
